import * as Sentry from "@sentry/react";

import { getCloudEnvironment } from "./location";

const SENTRY_PROJECT_ID = "4510465361903696";
const SENTRY_DSN =
  "https://447f0f20cf0c5ddaa714ca473fb18541@o4510465360789504.ingest.de.sentry.io";

const IS_DEVELOPMENT = process.env.NODE_ENV === "development";
const IS_CLOUD_BUILD = process.env.REACT_APP_BUILD_TYPE === "CLOUD";
const IS_SENTRY_ENABLED = process.env.REACT_APP_SENTRY_ENABLED === "true";

let isInitialized = false;

export const sentryReduxEnhancer = Sentry.createReduxEnhancer({
  stateTransformer: (state) => {
    return {
      ...state,
      app: {
        ...state.app,
        session: {
          ...state.app?.session,
          csrf: "sanitized-for-security",
        },
      },
    };
  },
});

export const initSentryTracking = () => {
  if (IS_DEVELOPMENT || !IS_CLOUD_BUILD || !IS_SENTRY_ENABLED) {
    return;
  }

  Sentry.init({
    dsn: `${SENTRY_DSN}/${SENTRY_PROJECT_ID}`,
    environment: getCloudEnvironment(),
    normalizeDepth: 5,

    // Disable session replays for now,
    // it's quite expensive against our current sub. budget.
    replaysSessionSampleRate: 0,
    replaysOnErrorSampleRate: 0,

    integrations: [
      Sentry.httpClientIntegration({
        failedRequestStatusCodes: [500, [400, 400], [402, 408]],
      }),
    ],
  });
  isInitialized = true;
};

export const setExtraSentryInfo = (data) => {
  const { application, userInfo } = data || {};
  const { gitCommit, productVersion } = application || {};
  const user = userInfo?.username;

  Sentry.setUser({ id: user, email: user });
  Sentry.setExtra({ gitCommit, productVersion });
  Sentry.setTags({ gitCommit, productVersion });
};

export const captureSentryException = (...args) => {
  if (isInitialized) {
    Sentry.captureException(...args);
  }
};

export const addSentryBreadcrumb = (breadcrumb) => {
  if (isInitialized) {
    Sentry.addBreadcrumb(breadcrumb);
  }
};
